import {
    createContext,
    useCallback,
    useContext,
    useMemo,
    useRef,
} from 'react';

const AnyProviderContext = createContext(null);

export function AnyProvider({ children }) {
    const scrollFnRef = useRef(null);

    const setScrollToItem = useCallback((fn) => {
        console.log('REGISTER SCROLL FUNCTION');
        scrollFnRef.current = fn;
    }, []);

    const scrollToItem = useCallback((index) => {
        console.log('EXECUTE SCROLL', index);

        if (scrollFnRef.current) {
            scrollFnRef.current(index);
        } else {
            console.warn('Embla scroll function has not been registered yet');
        }
    }, []);

    const embla_scroll = useMemo(
        () => ({
            scrollToItem,
            setScrollToItem,
        }),
        [scrollToItem, setScrollToItem]
    );

    return (
        <AnyProviderContext.Provider value={{ embla_scroll }}>
            {children}
        </AnyProviderContext.Provider>
    );
}

export function useAnyProvider() {
    const context = useContext(AnyProviderContext);

    if (!context) {
        throw new Error(
            'useAnyProvider must be used inside AnyProvider'
        );
    }

    return context;
}